import { TTSModels } from "@mw/shared/models";

import type { IUseCasePrompt } from "./types";

import { type IPrompt, type IUseCasePromptWithId, generatePromptId } from "./types";

export async function getDefaultPrompt(language: string, model: TTSModels) {
  let langFile;
  try {
    langFile = await import(`./promptData/${language}.ts`);
  } catch (error) {
    langFile = await import(`./promptData/${"en"}.ts`);
  }
  switch (model) {
    case TTSModels.ELEVEN_V3:
      return langFile.defaultV3Prompt as IPrompt;
    case TTSModels.ELEVEN_MULTILINGUAL_V2:
    case TTSModels.ELEVEN_TURBO_V2_5:
      return langFile.defaultV2Prompt as IPrompt;
    default:
      throw new Error(`Model ${model as any} not supported`);
  }
}

export async function getPromptsPerUseCase(language: string): Promise<IUseCasePromptWithId[] | undefined> {
  try {
    const textPrompts = await import(`./promptData/${language}.ts`);
    return textPrompts.perUseCase.map((prompt: IUseCasePrompt) => ({
      ...prompt,
      id: generatePromptId(prompt),
    })) as IUseCasePromptWithId[];
  } catch (error) {
    return undefined;
  }
}
